export class Chromosome {
	public name:string;
	public length:number;
	public idiogram:any;
	public genes:any;
}
